import React from 'react';
import { Divider, Tooltip, Button, Badge, Table } from 'antd';
import { httpClient } from "util/Api";
import { config } from "util/config";
import { GroupOutlined, PlusSquareOutlined, ProfileOutlined, EditOutlined, DeleteOutlined, OrderedListOutlined, FolderOutlined, FolderOpenOutlined, CaretRightOutlined, CaretDownOutlined } from '@ant-design/icons';
import { DragHandle, SortableItem, SortableBody, updateBeforeSortStart } from "components/UIBuilder/Global/SortableHelper";
import { arrayMoveImmutable } from 'array-move';
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import CustomBadge from 'components/CustomBadge';
import * as globalFunction from 'util/GlobalFunction';
import * as document from 'components/UIBuilder/SectionFunction/Document';

export default class JobDocumentFolder extends React.Component {
  constructor(props) {
    super();
    this.state = {
      data: [],
      keyArray: [],
      selectedRowKeys: [],
      sort: false,
    }
  }

  //停止排序时设置数据
  onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex !== newIndex) {
      const newData = arrayMoveImmutable(this.props.data.DocumentList.slice(), oldIndex, newIndex).filter(
        (el) => !!el,
      );

      let data = this.props.component.state.data;
      data = data.map((folder, i) => {
        if (folder.key === this.props.data.key) {
          folder.DocumentList = newData;
        }
        return folder;
      });
      this.props.component.setState({ data });

      var keyArray = newData.map((item, index) => {
        return item.key;
      });
      operationalFunction({ functionName: 'sortBySection', sectionName: this.props.component.props.sectionName, parameter: keyArray, sectionComponent: this.props.component.props.parentComponent, pageComponent: this.props.component.props.pageComponent });
    }
  };

  DraggableContainer = (props) => (
    <SortableBody
      useDragHandle
      disableAutoscroll
      helperClass="row-dragging"
      updateBeforeSortStart={updateBeforeSortStart}
      onSortEnd={this.onSortEnd}
      {...props}
    />
  );

  DraggableBodyRow = ({ className, style, ...restProps }) => {
    const index = this.props.data.DocumentList.findIndex((x) => x.key === restProps['data-row-key']);
    return <SortableItem index={index} {...restProps} />;
  };

  render() {
    let columns = [];
    if (this.state.sort) {
      columns.push({
        title: '',
        dataIndex: 'Sort',
        fixed: config.component.Table.fixed,
        className: 'drag-visible',
        render: () => <DragHandle />,
      })
    }
    this.props.columns.map((column, i) => {
      columns.push(column);
    })

    return (
      <div
        className='folder-div'
        style={{
          marginBottom: '20px'
        }}
        // onDragOver={(e) => {
        //   e.stopPropagation();
        //   e.preventDefault();
        // }}
        // onDrop={(e) => {
        //   e.preventDefault();
        //   e.stopPropagation();
        //   let sectionComponent = globalFunction.getSectionComponent(this.props.pageComponent, 'Document');
        //   document.addBySection({ sectionComponent: sectionComponent, pageComponent: this.props.pageComponent });
        //   let files = e.dataTransfer.files;
        //   setTimeout(() => {
        //     document.dropDocument({ files: files, component: sectionComponent.child.current?.uploadDocument.current });
        //     sectionComponent.child.current?.uploadDocument.current?.formRef.current?.setFieldValue('DocumentTypeId', 0);
        //     sectionComponent.child.current?.uploadDocument.current?.formRef.current?.setFieldValue('JobDocumentFolderId', this.props.data.key);
        //   }, config.setTimeoutMilliSecond);
        // }}
      >
        <div>
          <Button
            icon={<CustomBadge icon={this.props.data.Collapsed === true ?
              <CaretRightOutlined style={{ marginRight: '4px' }} /> :
              <CaretDownOutlined style={{ marginRight: '4px' }} />}
              text={this.props.data.Name + ' (' + this.props.data.DocumentList.length + ')'}
              backgroundColor={this.props.data.BackgroundColor != null ? this.props.data.BackgroundColor : config.component.ColorPicker.defaultColor}
              verticalAlign="top" />}
            type="link"
            style={{ width: 'auto', color: '#495057', padding: '0px', height: '18px', lineHeight: '18px' }}
            onClick={() => {
              let data = this.props.component.state.data.map((folder, i) => {
                if (folder.key === this.props.data.key) {
                  if (folder.Collapsed !== true) {
                    folder.Collapsed = true;
                  } else {
                    folder.Collapsed = false;
                  }
                }
                return folder;
              });
              this.props.component.setState({ data });
            }}
          />
        </div>
        <Divider />
        <div>
          {
            this.props.data.DocumentList.length > 0 ?
              <Table
                bordered
                size="small"
                style={{ display: this.props.data.Collapsed !== true ? 'block' : 'none' }}
                rowSelection={this.props.viewConfig.groupList[0].rowSelectionType !== null ? {
                  selectedRowKeys: this.state.selectedRowKeys,
                  type: this.props.viewConfig.groupList[0].rowSelectionType,
                  onChange: (selectedRowKeys, selectedRows) => {
                    this.setState({
                      selectedRowKeys
                    });
                  },
                  onSelect: (record, selected, selectedRows, nativeEvent) => {
                    let selectedRowKeys = this.props.component.state.selectedRowKeys;
                    if (selected) {
                      selectedRowKeys.push(record.key);
                    } else {
                      selectedRowKeys = selectedRowKeys.filter(item => item !== record.key);
                    }
                    this.props.component.setState({ selectedRowKeys });
                  },
                  onSelectAll: (selected, selectedRows, changeRows) => {
                    let selectedRowKeys = this.props.component.state.selectedRowKeys;
                    changeRows.map((record, i) => {
                      if (selected) {
                        selectedRowKeys.push(record.key);
                      } else {
                        selectedRowKeys = selectedRowKeys.filter(item => item !== record.key);
                      }
                    })
                    this.props.component.setState({ selectedRowKeys });
                  },
                  defaultSelectedRowKeys: []
                } : null}
                columns={columns}
                dataSource={this.props.data.DocumentList}
                scroll={config.component.Table.scroll}
                pagination={false}
                components={this.state.sort ? //判断是否带排序功能
                  {
                    body: {
                      wrapper: this.DraggableContainer,
                      row: this.DraggableBodyRow,
                    },
                  } : null}
                onRow={(record, index) => {
                  return {
                    onClick: event => { }, // 点击行
                    onDoubleClick: event => { }, // 双击行
                    onContextMenu: event => { }, //右击行
                    onMouseEnter: event => { }, // 鼠标移入行
                    onMouseLeave: event => { }, // 鼠标移出行
                  };
                }}
              /> : <></>
          }
        </div>
      </div >
    )
  }
}
